import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Users, Shield, UserPlus, Bell } from "lucide-react";
import UserManagement from "./components/UserManagement";
import RoleManagement from "./components/RoleManagement";
import ClientOnboarding from "./components/ClientOnboarding";
import ReleaseNotifications from "./components/ReleaseNotifications";
import AddUserModal from "./components/AddUserModal";
import OnboardingModal from "./components/OnboardingModal";
import {
  useUser
} from "@clerk/clerk-react";
import "./system-admin.scss";

export default function SystemAdmin() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();
  let client= user?.publicMetadata?.client;
  // Valid tabs - default to "users" if invalid tab in URL
  const validTabs = ["users", "roles", "onboarding", "notifications"];
  const activeTab = validTabs.includes(tab) ? tab : "users";
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);

  const tabs = [
    { id: "users", label: "User Management", icon: Users, show: true },
    { id: "roles", label: "Role Management", icon: Shield, show: true },
    { id: "onboarding", label: "Client Onboarding", icon: UserPlus, show: client?.name === "Helxon" },
    { id: "notifications", label: "Release Notifications", icon: Bell, show: client?.name === "Helxon" },
  ];

  return (
    <div className="system-admin">
      {/* Page Header */}
      <div className="system-admin__header">
        <div>
          <h1 className="system-admin__title">System Administration</h1>
          <p className="system-admin__subtitle">
            Manage users, roles, and system permissions
          </p>
        </div>
        <div className="system-admin__controls"></div>
      </div>

      {/* Tab Navigation */}
      <div className="system-admin__tabs">
        {tabs.filter((tab) => tab.show).map((tab) => {
          const IconComponent = tab.icon;
          return (
            <button
              key={tab.id}
              className={`system-admin__tab ${
                activeTab === tab.id ? "system-admin__tab--active" : ""
              }`}
              onClick={() => navigate(`/system-admin/${tab.id}`)}
            >
              <IconComponent size={16} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="system-admin__content">
        {activeTab === "users" && (
          <UserManagement onClickAddUser={() => setShowAddUserModal(true)} />
        )}
        {activeTab === "roles" && <RoleManagement />}
        { client?.name === "Helxon" && activeTab === "onboarding" && (
          <ClientOnboarding
            onClickAddClient={() => setShowOnboardingModal(true)}
          />
        )}
        { client?.name === "Helxon" && activeTab === "notifications" && <ReleaseNotifications />}
      </div>

      {/* Add User Modal */}
      {showAddUserModal && (
        <AddUserModal
          onClose={() => setShowAddUserModal(false)}
          onUserAdded={() => {
            setShowAddUserModal(false);
            // Refresh user list if needed
          }}
        />
      )}

      {/* Onboarding Modal */}
      {showOnboardingModal && (
        <OnboardingModal
          onClose={() => setShowOnboardingModal(false)}
          onComplete={() => {
            setShowOnboardingModal(false);
            // Client list will auto-refresh via Redux
          }}
        />
      )}
    </div>
  );
}
